/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { CreateOrderbookOptions, CreateOrderbookResponses } from '../types/CreateOrderbook'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Create a new orderbook
 * {@link /v1/orderbooks}
 */
export function createOrderbook<ThrowOnError extends boolean = true>(
  options: Options<CreateOrderbookOptions, ThrowOnError>,
): Unwrappable<RequestResult<CreateOrderbookResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/orderbooks',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CreateOrderbookResponses, ThrowOnError>>,
  )
}
